import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SectorSelectionPage.css";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const SectorSelectionPage = () => {
   const navigate = useNavigate();
   const [selectedSector, setSelectedSector] = useState(null);
   const jwt = Cookies.get("jwt");
   const decoded = jwt ? jwtDecode(jwt) : null;
   const gmail = decoded?.email;

   // CUSTOMER REDIRECT: Customers should not see this page
   React.useEffect(() => {
      if (decoded?.userType === 'customer') {
         navigate('/dashboard');
      }
   }, [decoded, navigate]);

   const sectors = [
      {
         id: "e-commerce",
         name: "E-Commerce",
         icon: "fas fa-shopping-cart",
         description: "Online store with product catalog, shopping cart, and checkout",
         features: ["Product Management", "Shopping Cart", "Inventory Tracking", "Order Management"],
      },
      {
         id: "fashion",
         name: "Fashion",
         icon: "fas fa-tshirt",
         description: "Fashion boutique with lookbook, product gallery, and style guides",
         features: ["Lookbook Gallery", "Size Guides", "Collection Display", "Style Categories"],
      },
      {
         id: "automobile",
         name: "Automobile",
         icon: "fas fa-car",
         description: "Automobile services with booking system, vehicle showcase, and service history",
         features: ["Service Booking", "Vehicle Showcase", "Service History", "Parts Catalog"],
      },
      {
         id: "food",
         name: "Food & Restaurant",
         icon: "fas fa-utensils",
         description: "Restaurant with menu display, table booking, and online ordering",
         features: ["Menu Display", "Table Booking", "Online Ordering", "Delivery Tracking"],
      },
      {
         id: "health",
         name: "Health & Wellness",
         icon: "fas fa-heartbeat",
         description: "Health services with appointment booking, practitioner profiles, and patient records",
         features: ["Appointment Booking", "Practitioner Profiles", "Service Listings", "Health Tips"],
      },
      {
         id: "entertainment",
         name: "Entertainment",
         icon: "fas fa-film",
         description: "Entertainment business with event listings, ticketing, and venue information",
         features: ["Event Listings", "Ticket Booking", "Venue Information", "Event Calendar"],
      },
      {
         id: "electronics",
         name: "Electronics",
         icon: "fas fa-laptop",
         description: "Electronics store with product specs, comparison tools, and tech reviews",
         features: ["Product Specifications", "Comparison Tools", "Tech Reviews", "Warranty Info"],
      },
      {
         id: "finance",
         name: "Finance",
         icon: "fas fa-money-bill-wave",
         description: "Financial services with service listings, consultation booking, and trust elements",
         features: ["Service Listings", "Consultation Booking", "Financial Tools", "Client Portal"],
      },
   ];

   const handleSectorSelect = (sectorId) => {
      setSelectedSector(sectorId);
   };

   const handleContinue = async () => {
      if (!selectedSector) {
         alert("Please select a business sector to continue");
         return;
      }

      // Save selected sector to backend
      try {
         const url = process.env.REACT_APP_BACKEND_URL;
         const response = await fetch(`${url}/api/business/sector`, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify({
               email: gmail,
               businessType: selectedSector,
            }),
         });

         if (response.ok || response.status === 200) {
            // Navigate to templates page with sector info
            navigate(`/templates?sector=${selectedSector}`);
         } else {
            console.error("Failed to save sector selection");
            // Still navigate even if save fails
            navigate(`/templates?sector=${selectedSector}`);
         }
      } catch (error) {
         console.error("Error saving sector:", error);
         // Navigate even on error
         navigate(`/templates?sector=${selectedSector}`);
      }
   };

   return (
      <div className="sector-selection-page">
         <div className="container">
            <div className="sector-selection-header">
               <h1 className="page-title">Choose Your Business Sector</h1>
               <p className="page-subtitle">
                  Select the sector that best describes your business. We'll customize your website
                  template accordingly.
               </p>
            </div>

            <div className="sectors-grid">
               {sectors.map((sector) => (
                  <div
                     key={sector.id}
                     className={`sector-card ${selectedSector === sector.id ? "selected" : ""}`}
                     onClick={() => handleSectorSelect(sector.id)}
                  >
                     <div className="sector-icon"><i className={sector.icon}></i></div>
                     <h3 className="sector-name">{sector.name}</h3>
                     <p className="sector-description">{sector.description}</p>
                     <ul className="sector-features">
                        {sector.features.map((feature, index) => (
                           <li key={index}>{feature}</li>
                        ))}
                     </ul>
                     <div className="sector-check">
                        {selectedSector === sector.id && (
                           <span className="check-icon">✓</span>
                        )}
                     </div>
                  </div>
               ))}
            </div>

            <div className="sector-selection-footer">
               <button
                  className="continue-button"
                  onClick={handleContinue}
                  disabled={!selectedSector}
               >
                  Continue to Templates
               </button>
            </div>
         </div>
      </div>
   );
};

export default SectorSelectionPage;

